export enum NieuwbouwEnum {
  NIEUWBOUW = 'Nieuwbouw',
}
